import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip, Grid } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import { withRouter } from 'react-router-dom';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers';
import PageHeader from 'main/components/PageHeader';
import TableFilter from 'main/components/tableFilter/TableFilter';
import * as TableFilterActions from 'main/components/tableFilter/store/actions';

const styles = theme => ({
    layoutRoot: {},
});

class ModuleList extends Component {

    constructor(props) {
        super(props);
        this.props.getModuleList('list');
    }

    componentWillUnmount = () => {
        this.props.setTableFilter(this.props.auth.user.data.auth_id, 'ModuleList', this.props.filterList.filterColumns);
        this.props.clearFilterStore();
    }

    checkLockPermission = (row) => {
        const auth_id = this.props.auth.user.data.auth_id;
        const role = this.props.auth.user.role;
        if (row.IsLocked === 0) {
            return true
        }
        else {
            if (role === 'dev' || role === 'admin' || role === 'company') {
                return true
            }
            else if (role === 'instructor' && row.LockedByAuthID === auth_id) {
                return true
            }
        }
        return false
    }

    editAllow = (row) => {
        if (this.checkLockPermission(row)) {
            let tooltipContent = 'Edit';
            if (row.IsLocked === 1) {
                tooltipContent = <React.Fragment><div>Edit</div><div>(Locked)</div></React.Fragment>
            }
            return (
                <Tooltip title={tooltipContent}>
                    <IconButton
                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                        onClick={(ev) => {
                            ev.stopPropagation();
                            this.handleRowClick('edit', row.module_id);
                        }}
                    >
                        <Icon>border_color</Icon>
                    </IconButton>
                </Tooltip>
            )
        }
        else {
            return (
                <Tooltip title="This module is locked">
                    <Icon style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }} >lock</Icon>
                </Tooltip>
            )
        }

    }

    handleRowClick(page_type, module_id) {
        this.props.history.push(`/module/${page_type}/${module_id}`);
    }

    checkFilterValueSaved = (column) => {
        const { table_filter } = this.props
        if (!table_filter['ModuleList']) {
            return false
        }
        if (!table_filter['ModuleList'].find(col => col.id === column)) {
            return false
        }

        else {
            return table_filter['ModuleList'].find(col => col.id === column).value.filterValue
        }
    }

    getTrProps = (state, rowInfo, instance) => {
        if (rowInfo) {
            if (rowInfo.original.Active === 0) {
                return {
                    style: {
                        background: '#a85e59'
                    } 
                }
            }
        }
        return {};
    }

    render() {
        const { classes, moduleList, auth, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded || !this.props.moduleListLoadedAfterSave || !this.props.listLoaded ) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <PageHeader
                        component_type={"module"}
                        view_type={"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name={"module"}
                            view_type={"list"}
                            button_list={[
                                {
                                    display: "Add",
                                    type: "create",
                                    color: "primary",
                                    onClick: () => this.props.history.push("/module/create"),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <Grid container style={{ height: '100%' }}>
                        <Grid item xs={9}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <ReactTable
                                    style={{ position: 'absolute' }}
                                    columns={[
                                        {
                                            Header: "Module Name",
                                            accessor: "ModuleName",
                                            Cell: row => (
                                                <TableCellTooltip
                                                    item={row.original.ModuleName}
                                                    chars={20}
                                                />
                                            )
                                        },
                                        {
                                            Header: "Module Description",
                                            accessor: "ModuleDescription",
                                            Cell: row => (
                                                <TableCellTooltip
                                                    item={row.original.ModuleDescription}
                                                    chars={20}
                                                />
                                            )
                                        },
                                        {
                                            Header: "Actions",
                                            maxWidth: 150,
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    <Tooltip title="Detail">
                                                        <IconButton
                                                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                this.handleRowClick('detail', row.original.module_id);
                                                            }}
                                                        >
                                                            <Icon>library_books</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                    {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "module", "edit") ? null :
                                                        this.editAllow(row.original)
                                                    }
                                                </div>
                                            )
                                        }
                                    ]}
                                    data={this.props.filterList.filteredDataList}
                                    defaultPageSize={25}
                                    pageSize={table_page_size[table_name]}
                                    className="-striped -highlight"
                                    noDataText="No Modules Found"
                                    defaultSorted={table_sort[table_name]}
                                    onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                                    filterable={false}
                                    getTrProps={this.getTrProps}
                                    defaultFiltered={table_filter[table_name]}
                                    onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={3} style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                            <div style={{ position: 'relative', height: '100%', width: '100%' }}>
                                <TableFilter
                                    componentName={'ModuleList'}
                                    defaultList={moduleList}
                                    preloadValues={table_filter['ModuleList'] ? true : false}
                                    columns={[
                                        {
                                            columnName: 'Module Name',
                                            column_id: 'ModuleName',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('ModuleName') || '',
                                            active: this.checkFilterValueSaved('ModuleName') ? true : false
                                        },
                                        {
                                            columnName: 'Module Description',
                                            column_id: 'ModuleDescription',
                                            columnType: 'string',
                                            filterType: 'string_contains',
                                            value: this.checkFilterValueSaved('ModuleDescription') || '',
                                            active: this.checkFilterValueSaved('ModuleDescription') ? true : false
                                        },
                                        {
                                            columnName: 'Active',
                                            column_id: 'Active',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: this.checkFilterValueSaved('Active') ? Number(this.checkFilterValueSaved('Active')) : 2,
                                            // active: Number(this.checkFilterValueSaved('Active')) !== 0
                                            active: true
                                        },
                                        {
                                            columnName: 'Unscheduled',
                                            column_id: 'Unscheduled',
                                            columnType: 'binary_switch',
                                            filterType: 'binary_switch',
                                            // 0 off, 1 false, 2 true
                                            value: Number(this.checkFilterValueSaved('Unscheduled')),
                                            active: Number(this.checkFilterValueSaved('Unscheduled')) !== 0
                                        },
                                        {
                                            columnName: 'Tags',
                                            column_id: 'Labels',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.moduleListSearchable.labels,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Labels'),
                                            active: this.checkFilterValueSaved('Labels').length > 0
                                        },
                                        {
                                            columnName: 'Companies',
                                            column_id: 'Companies',
                                            columnType: 'array',
                                            filterType: 'array_search',
                                            searchableValues: this.props.moduleListSearchable.companies,
                                            switchVal: false,
                                            value: this.checkFilterValueSaved('Companies'),
                                            active: this.checkFilterValueSaved('Companies').length > 0
                                        },
                                    ]}
                                />
                            </div>
                        </Grid>
                    </Grid>

                }
            />
        );
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getModuleList: Actions.getModuleList,
        setTableSort: TableActions.setTableSort,
        setTableFilter: TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
        clearFilterStore: TableFilterActions.clearFilterStore,
        setTableFilter: TableFilterActions.saveTableFilter,
    }, dispatch);
}

function mapStateToProps({ moduleApp, auth, tableSort, tableFilter }) {
    return {
        moduleList: moduleApp.modules.moduleList,
        moduleListLoadedAfterSave: moduleApp.modules.moduleListLoadedAfterSave,
        listLoaded: moduleApp.modules.listLoaded,
        moduleListSearchable: moduleApp.modules.moduleListSearchable,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded: tableSort.is_loaded,
        filterList: tableFilter,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModuleList)));


// WEBPACK FOOTER //
// src/main/content/module/ModuleList.js